import { Localization } from "../../../common/localizable-component";
import { DropdownLocalization } from "./dropdown-types";

export const DROPDOWN_LOCALIZATION: Localization<DropdownLocalization> = {
  en: {
    required: 'The field "{fieldName}" is required.',
    selected: "selected"
  },
  de: {
    required: 'Das Feld "{fieldName}" wird benötigt.',
    selected: "ausgewählt"
  },
  sv: {
    required: 'Fältet "{fieldName}" är obligatoriskt.',
    selected: "utvalda"
  },
  nl: {
    required: 'Het veld "{fieldName}" is verplicht.',
    selected: "geselecteerde"
  },
  it: {
    required: 'Il campo "{fieldName}" è obbligatorio.',
    selected: "selezionato"
  },
  hu: {
    required: 'A(z) "{fieldName}" mező kitöltése kötelező.',
    selected: "kiválasztott"
  },
  da: {
    required: 'Feltet "{fieldName}" er obligatorisk.',
    selected: "udvalgt"
  },
  fr: {
    required: 'Le champ "{fieldName}" est obligatoire.',
    selected: "sélectionné"
  },
  es: {
    required: 'El campo "{fieldName}" es obligatorio.',
    selected: "seleccionado"
  },
  pl: {
    required: 'Pole "{fieldName}" jest wymagane.',
    selected: "wybrane"
  },
  ro: {
    required: 'Câmpul "{fieldName}" este obligatoriu.',
    selected: "selectat"
  },
  hr: {
    required: 'Polje "{fieldName}" je obavezno.',
    selected: "odabran"
  },
  cs: {
    required: 'Pole "{fieldName}" je povinné.',
    selected: "vybrané"
  },
  sl: {
    required: 'Polje "{fieldName}" je obvezno.',
    selected: "izbrani"
  }
};
